import Vue from 'vue';
import Vuex from 'vuex';
import api from '@groovepages/gd-lib/api';
import Auth from '@groovepages/gd-lib/auth';

Vue.use(Vuex);

const pagesUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovepages`;
const coreUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovedigital`;

export default new Vuex.Store({
  state: {
    userMeta: {},
    zones: {},
    records: {}
  },
  mutations: {
    setUserMeta(state, userMeta) {
      state.userMeta = userMeta;
    },
    setZones(state, zones) {
      state.zones = {};
      zones.map(zone => {
        Vue.set(state.zones, zone.name, zone);
        Vue.set(state.records, zone.name, {});
      });
    },
    addZone(state, zone) {
      Vue.set(state.zones, zone.name, zone);
    },
    removeZone(state, { name }) {
      Vue.delete(state.zones, name);
      Vue.delete(state.records, name);
    },
    setRecords(state, { domain, records }) {
      Vue.set(state.records, domain, {});
      records.map(record => Vue.set(state.records[domain], record.id, record));
    },
    addRecord(state, { domain, record }) {
      Vue.set(state.records[domain], record.id, record);
    },
    removeRecord(state, { domain, id }) {
      Vue.delete(state.records[domain], id);
    }
  },
  actions: {
    async updateUserMeta({ commit }, metadata) {
      const { id } = Auth.authenticatedUser();
      const result = await api.post(`${ window.gdEnv.VUE_APP_API_URL }/groovedigital/auth/users/update-meta/${ id }`, metadata);
      Auth.updateMeta(result);
      commit('setUserMeta', result);
    },
    async getDomain({ commit }, domain) {
      const zone = await api.get(`${ pagesUrl() }/zones?domain=${ domain }`);
      commit('addZone', zone);
      return zone;
    },
    async addDomain({ commit, dispatch }, { domain, hosted, platform }) {
      const { domains } = await api.post(`${ pagesUrl() }/zones`, { domain, hosted, platform });
      if (hosted) await dispatch('getDomain', domain);
      return domains;
    },
    async deleteDomain({ state, commit }, domain) {
      const zone = state.zones[domain];
      const { domains } = await api.api('delete', `${ pagesUrl() }/zones/${ zone ? zone.id : 'external' }`, { domain }, true);
      if (zone) {
        commit('removeZone', zone);
      }
      return domains;
    },
    async checkIfZoneActive(ctx, domain) {
      const zone = state.zones[domain];
      if (!zone) throw new Error('zone_domain_not_found');
      await api.get(`${ pagesUrl() }/zones/${ zone.id }/status`);
    },
    async getDnsRecords({ commit }, { id, name }) {
      const records = await api.get(`${ pagesUrl() }/zones/${ id }/records`);
      commit('setRecords', { domain: name, records });
      return records;
    },
    async addDnsRecord({ commit }, { zone, data }) {
      data.proxied = data.proxied ? 1 : 0;
      const record = await api.post(`${ pagesUrl() }/zones/${ zone.id }/records`, data);
      commit('addRecord', { domain: zone.name, record });
      return record;
    },
    async updateDnsRecord({ commit }, { zone, data }) {
      data.proxied = data.proxied ? 1 : 0;
      const record = await api.api('put', `${ pagesUrl() }/zones/${ zone.id }/records/${ data.id }`, data);
      commit('addRecord', { domain: zone.name, record });
      return record;
    },
    async deleteDnsRecord({ commit }, { zone, record: { id } }) {
      await api.delete(`${ pagesUrl() }/zones/${ zone.id }/records/${ id }`);
      commit('removeRecord', { domain: zone.name, id });
    },
    async fetchDomains({ commit }) {
      const domains = await api.get(`${ coreUrl() }/domains`);
      return domains.data;
    },
    async verifyDomainStatus(ctx, domain) {
      return api.get(`${ coreUrl() }/domains/check-status/${ domain }`);
    },
    async addUserDomain({ commit, dispatch }, { domain, type }) {
      return api.post(`${ coreUrl() }/domains`, { domain, type });
    },
    async fetchDnsRecords({ commit }, domain) {
      return api.get(`${ coreUrl() }/domains/fetch-dns-records/${ domain }`);
    },
  }
});
